/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { PillLabel } from '@mpb-com/feather/components/atoms/pill-label';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';

import { AsideMenu } from '@toucan/client/shared/components/aside-menu';
import { Link } from '@toucan/client/shared/components/link';

import {
    CollapsibleAside,
    CollapsibleAsideVariant,
} from '@toucan/client/blocks/components/collapsible-aside';

import { TEST_ID as dataTestId } from './constants';
import { styles } from './search-filter-menu.styles';
import { SearchFilterMenuProps } from './types';

const StyledSearchFilterMenu = styled('div')`
    ${styles}
`;

export const SearchFilterMenu: FunctionComponent<SearchFilterMenuProps> = ({
    filters,
    filtersAppliedCount,
}: SearchFilterMenuProps) => {
    const { t } = useTranslation();

    const titleExtraContent = useMemo(() => {
        if (filtersAppliedCount === 0) {
            return null;
        }
        return (
            <div className="search-filter-menu__extra-content">
                <Link
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    {t('Clear filters')}
                </Link>
                <PillLabel>
                    {t('{{count}} applied', {
                        count: filtersAppliedCount,
                    })}
                </PillLabel>
            </div>
        );
    }, [filtersAppliedCount]);

    return (
        <StyledSearchFilterMenu data-testid={dataTestId}>
            <AsideMenu
                data-testid={`${dataTestId}__aside`}
                title={
                    <Heading
                        size={HeadingSize.H3}
                        as={HeadingSize.H2}
                        className="search-filter-menu__heading"
                    >
                        {t('Focus your search')}
                    </Heading>
                }
                titleExtraContent={titleExtraContent}
            >
                {/* the content below is placeholder - TUR-2982, TUR-2983, TUR-2984 */}
                <p>{t('How it looks')}</p>
                <p>{t('Your budget')}</p>
                <CollapsibleAside
                    title={t('Advanced filters')}
                    variant={CollapsibleAsideVariant.INLINE}
                    data-testid={`${dataTestId}__aside__advanced-filters`}
                >
                    <p>{t('Accessories')}</p>
                </CollapsibleAside>
                {/* the content above is placeholder */}
            </AsideMenu>
        </StyledSearchFilterMenu>
    );
};
